import { format } from 'date-fns';
import { FC } from 'react';

import { IconButton } from '../Button';
import ChevronLeftIcon from './assets/chevron-left.svg';
import ChevronRightIcon from './assets/chevron-right.svg';
import {
  StyledArrowSpacer,
  StyledHeader,
  StyledStaticMonthLabel,
} from './DatePickerNavHeader.styled';

interface Props {
  month: Date;
  onPrev?: () => void;
  onNext?: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}

/**
 * One month label with an optional arrow on either side. Rendered as a sibling of
 * its `DateCalendar` rather than through the `calendarHeader` slot: the calendars
 * remount when the month changes, which would destroy the arrow the user just
 * activated and drop keyboard focus to the body.
 */
export const RangeCalendarHeader: FC<Props> = ({
  month,
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
}) => (
  <StyledHeader>
    {onPrev ? (
      <IconButton
        color="tertiary"
        variant="outline"
        size="xs"
        onClick={onPrev}
        disabled={prevDisabled}
        aria-label="Previous month"
      >
        <ChevronLeftIcon />
      </IconButton>
    ) : (
      <StyledArrowSpacer />
    )}

    <StyledStaticMonthLabel>{format(month, 'MMMM yyyy')}</StyledStaticMonthLabel>

    {onNext ? (
      <IconButton
        color="tertiary"
        variant="outline"
        size="xs"
        onClick={onNext}
        disabled={nextDisabled}
        aria-label="Next month"
      >
        <ChevronRightIcon />
      </IconButton>
    ) : (
      <StyledArrowSpacer />
    )}
  </StyledHeader>
);
